import moment from 'moment'

export function parseTime(time, cFormat) {
//
}

export function formatTime(time, option) {
//
}

export function formatDate(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
}

export function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')
  }
}
